import DinamicCrudCustomForm from './DinamicCrudCustomForm'
import enhance from './DinamicCrudCustomForm.enhancer'

export default enhance(DinamicCrudCustomForm)



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicForms/components/DinamicCrudCustomFormDialog/index.js